import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { IFieldBook, IFieldBookAllResponse, IFieldBookCatalogResponse } from "../models";
import { URLConfig } from "../network/urlStore";

export const getFieldJournal = (
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<IFieldBookAllResponse> => {
  let url = URLConfig.getFieldBookURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IFieldBookAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching field Journal data", error);
      }
    );
  });
};
export const getFieldJournalNextPage = (
  nextPageURI: string
): Observable<IFieldBookAllResponse> => {
  const url = URLConfig.getFieldBookNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as IFieldBookAllResponse;

          subscriber.next(locationsResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations field Journal data", error);
      }
    );
  });
};

export const updateFieldBook = (
  answerPlotLocationId: string,
  requestPayload?: any,
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = `${URLConfig.getFieldBookURL()}/location/${answerPlotLocationId}`;
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the Field Journal", error);
      }
    );
  });
};

export const getContentLengthForFieldJournal = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getFieldBookURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Field Journal Data:", error);
      });
  });
};

export const updateRepStatus = (
  answerPlotLocationId: string,
  // trialId: number,
  requestPayload?: any,
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<any> => {
  // let url = URLConfig.updateRepStatusURL(answerPlotLocationId);
  let url = `${URLConfig.getRepInfoTrialMasterURL()}/location/${answerPlotLocationId}`;
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the Field Journal", error);
      }
    );
  });
};

export const getAllFieldBook = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IFieldBook[]> => {
  let url = URLConfig.getFieldBookURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  let allFieldBooks: IFieldBook[] = [];
  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };



    const responseHandler = (response: IFieldBookAllResponse) => {
      const fieldBookResponse = response;
      allFieldBooks = [...allFieldBooks, ...(fieldBookResponse.values || [])];

      if (fieldBookResponse.nextPageUri) {
        getFieldJournalNextPage(fieldBookResponse.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching all field book records");
          },
        });
      } else {
        subscriber.next(allFieldBooks);
        subscriber.complete();
      }
    };

    getFieldJournal(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching field book records");
      },
    });
  });
};

export const deleteDemoFieldBookEntries = (requestPayload: any,  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>): Observable<any> => {
  let url = URLConfig.deleteDemoFieldBookURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (res: unknown) => {
        // Always emit a value, even if response is empty
        subscriber.next(res ?? {});
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while deleting demo field book entries", error);
      }
    );
  });
};

export const updateRandomizedTreatments = (
  answerPlotLocationId: string,
  // trialId: number,
  requestPayload?: any,
  queryParams?: Array<{
    key: OdQueryParam | AgTechQueryParam;
    value: string[];
  }>
): Observable<any> => {
  // let url = URLConfig.updateRepStatusURL(answerPlotLocationId);
  let url = `${URLConfig.getRepInfoTrialMasterURL()}/location/${answerPlotLocationId}`;
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
 
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the Field Journal", error);
      }
    );
  });
};
 
export const getFieldBookCatalog = (
  queryParams: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IFieldBookCatalogResponse> => {
  let url = URLConfig.getFieldBookCatalogURL();
  for (const param of queryParams) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IFieldBookCatalogResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching FieldBook Catalog", error);
      }
    );
  });
};

export const getFieldBookCatalogNextPage = (
  nextPageURI: string
): Observable<IFieldBookCatalogResponse> => {
  const url = URLConfig.getFieldBookCatalogNextPageURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const response = res as unknown as IFieldBookCatalogResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching FieldBook Catalog next page", error);
      }
    );
  });
};

export const getAllFieldBookCatalog = (
  queryParams: Array<{ key: OdQueryParam; value: string[] }>
): Observable<IFieldBookCatalogResponse["values"]> => {
  let allValues: IFieldBookCatalogResponse["values"] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };

    const responseHandler = (response: IFieldBookCatalogResponse) => {
      allValues = [...allValues, ...(response.values || [])];

      if (response.nextPageUri) {
        getFieldBookCatalogNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
        });
      } else {
        subscriber.next(allValues);
        subscriber.complete();
      }
    };

    getFieldBookCatalog(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
    });
  });
};

export const getContentLengthForFieldBookCatalog = (
  queryParams: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getFieldBookCatalogURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Field Journal Data:", error);
      });
  });
};

export const getFieldBookProcessingStatus = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.getFieldBookProcessingStatusURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Milk Per Ton Calculation Status", error);
      }
    );
  });
};

